import { NavLink } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { EonLogo } from '../shared/EonLogo'

export function AdminSidebar({ inkorgsAntal = 0 }) {
  const { medarbetare, logOut } = useAuth()

  const initials = medarbetare
    ? `${medarbetare.fornamn[0]}${medarbetare.efternamn[0]}`
    : 'AD'

  return (
    <aside className="sidebar">
      <div className="sidebar-top">
        <EonLogo size={40} borderRadius={8} />
        <div>
          <div className="sidebar-logo-text">E.ON Schema</div>
          <div className="sidebar-logo-sub">Adminpanel</div>
        </div>
      </div>

      <nav className="sidebar-nav">
        <div className="sidebar-section">Schema</div>

        <NavLink
          to="/admin/schema"
          className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
        >
          <span className="icon">📅</span>
          Helhetsschema
        </NavLink>

        <NavLink
          to="/admin/inkorg"
          className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
        >
          <span className="icon">📥</span>
          Inkorg
          {inkorgsAntal > 0 && (
            <span className="nav-badge">{inkorgsAntal}</span>
          )}
        </NavLink>

        <div className="sidebar-section">Hantera</div>

        <NavLink
          to="/admin/medarbetare"
          className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
        >
          <span className="icon">👥</span>
          Medarbetare
        </NavLink>

        <NavLink
          to="/admin/ladda-upp"
          className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
        >
          <span className="icon">📂</span>
          Ladda upp schema
        </NavLink>

        <NavLink
          to="/admin/passtyper"
          className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
        >
          <span className="icon">⚙️</span>
          Passtyper
        </NavLink>

        <NavLink
          to="/admin/sap"
          className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
        >
          <span className="icon">📋</span>
          SAP-underlag
        </NavLink>

        <div className="sidebar-section">Hjälp</div>

        <NavLink
          to="/admin/manual"
          className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
        >
          <span className="icon">📖</span>
          Manual
        </NavLink>
      </nav>

      <div className="sidebar-footer">
        <div className="user-chip">
          <div className="user-avatar">{initials}</div>
          <div>
            <div className="user-name">
              {medarbetare ? `${medarbetare.fornamn} ${medarbetare.efternamn}` : 'Admin'}
            </div>
            <div className="user-role">Schemaansvarig</div>
          </div>
        </div>
        <button className="btn-logout" onClick={logOut}>← Logga ut</button>
      </div>
    </aside>
  )
}
